import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Returns true when two dates fall on the same calendar day (year/month/day),
 * ignoring time. Returns false if either date is null.
 *
 * Previously lived in the (now-deleted) table2/VirtualizedTableWithoutBulkActions;
 * relocated here since AgGridTable is the only consumer.
 */
export const datesAreEqual = (date1: Date | null, date2: Date | null): boolean => {
    if (!date1 || !date2) {
        return false
    }

    const year1 = date1.getFullYear()
    const month1 = date1.getMonth()
    const day1 = date1.getDate()

    const year2 = date2.getFullYear()
    const month2 = date2.getMonth()
    const day2 = date2.getDate()

    if (year1 !== year2) {
        return false
    }

    if (month1 !== month2) {
        return false
    }

    return day1 === day2
}

/**
 * Hook returning a callback that merges the given params into the current URL
 * query string and replaces the history entry.
 */
export const useUpdateQueryParams = () => {
    const navigate = useNavigate()
    const location = useLocation()

    return (updatedParams: { [key: string]: string }) => {
        const searchParams = new URLSearchParams(location.search)

        for (const [key, value] of Object.entries(updatedParams)) {
            searchParams.set(key, value)
        }

        // @ts-ignore
        navigate({
            pathname: location.pathname,
            search: '?' + searchParams.toString(),
            replace: true,
        })
    }
}
